export default "__VITE_ASSET__225ee70e__"